import { useMemo } from 'react';
import { useCurrentUser } from 'FrontRoyalAngular';
import { useAngularContext } from 'AngularContext';
import { type LocaleAngularObject } from 'Locale';
import { getRelevantCohorts } from 'Users';

/*
    The two values every dashboard stream request needs.

    userCohortIds is null for a signed-out visitor, which is what optionsForGetCalls keys the whole
    signed-out branch off; an empty array would filter everything out instead of filtering nothing.
*/
export function useStreamRequestOptions() {
    const currentUser = useCurrentUser();
    const $injector = useAngularContext();

    const userCohortIds = useMemo(
        () => (currentUser ? getRelevantCohorts(currentUser).map(cohort => cohort.id) : null),
        [currentUser],
    );

    return { userCohortIds, prefLocale: $injector.get<LocaleAngularObject>('Locale').activeCode };
}
